import _ from "lodash";
import gql from "graphql-tag";
import graphqlClient, { fragments as requestFragments } from "@/http/graphql/request";

export const GET_REQUEST_TYPES = `
    request_types (
		page: $page,
		limit: $limit,
		keyword: $keyword,
		orderBy: $orderBy,
		list_all: $list_all
	) {
		...RequestTypes
	}
`;

export const GET_REQUESTS = `
	requests(
		version: "v2",
		page: $page,
		limit: $limit,
		search: $search,
		to_date: $to_date,
		orderBy: $orderBy,
		can_edit: $can_edit,
		from_date: $from_date,
		req_type_id: $req_type_id,
		list_statuses: $list_statuses,
		requested_by_me: $requested_by_me,
		approve_by_me: $approve_by_me,
		req_type_type_id: $req_type_type_id,
		waiting_approval: $waiting_approval,
		advantage_search: $advantage_search,
		list_requested_by: $list_requested_by
	) {
		data {
			...Request
		}
		total
		last_page
	}
`;

export const GET_REQUESTS_V2 = `
	requests(
		version: "v2",
		page: $page,
		limit: $limit,
		search: $search,
		to_date: $to_date,
		orderBy: $orderBy,
		can_edit: $can_edit,
		from_date: $from_date,
		req_type_id: $req_type_id,
		list_statuses: $list_statuses,
		requested_by_me: $requested_by_me,
		approve_by_me: $approve_by_me,
		req_type_type_id: $req_type_type_id,
		waiting_approval: $waiting_approval,
		advantage_search: $advantage_search,
		list_requested_by: $list_requested_by,
		department_ids: $department_ids,
		user_option: $user_option,
	) {
		data {
			...RequestSimpleData
		}
		total
		last_page
	}
`;

const RELATION_MODEL = `
	relation_model(model: $model, page: $page, limit: $limit, name: $name, ids: $ids) {
		total
		data {
			id
			content
		}
	}
`;

const GET_REQUEST = `
	request (id: $id, version: "v2") {
		...Request
	}
`;

const GET_AUTOFILL = `
	autofill_data (model_id: $model_id, model_class: $model_class, column: $column) {
		id
		content
	}
`;

const APPROVED_REQUEST = `
	approved_request(id: $id, note: $note, step_status: $step_status, version: "v2") {
		...Request
	}
`;

const REJECT_REQUEST = `
	reject_request(id: $id, reason: $reason, version: "v2") {
		...Request
	}
`;

const CANCEL_REQUEST = `
	cancel_request(id: $id, reason: $reason, version: "v2") {
		...Request
	}
`;

const SUBMIT_REQUEST = `
    submit_request (req_type_id: $req_type_id, request_reason: $request_reason, data: $data, relations: $relations, step_status: $step_status, version: "v2") {
		...Request
	}
`;

const SUBMIT_NEXT_REQUEST = `
    submit_next_request (id: $id, data: $data, version: "v2") {
		...Request
	}
`;

const UPDATE_REQUEST = `
	update_request (id: $id, request_reason: $request_reason, data: $data, version: "v2") {
		...Request
	}
`;

const EXPORT_REQUEST = `
	export_request(id: $id, version: "v2")
`;

const EXPORT_FILTERED_REQUEST_STATISTIC = `
	export_request_statistic(
		version: "v2",
		search: $search,
		to_date: $to_date,
		from_date: $from_date,
		req_type_id: $req_type_id,
		list_statuses: $list_statuses,
		waiting_approval: $waiting_approval,
		list_requested_by: $list_requested_by,
		advantage_search: $advantage_search
	)
`;

const EXPORT_FILTERED_REQUEST = `
	export_request_list(
		version: "v2",
		search: $search,
		to_date: $to_date,
		from_date: $from_date,
		req_type_id: $req_type_id,
		list_statuses: $list_statuses,
		waiting_approval: $waiting_approval,
		list_requested_by: $list_requested_by,
		advantage_search: $advantage_search,
		department_ids: $department_ids
	)
`;

const GET_REQUEST_TYPE = fragmentType => `
request_type (id: $id, list_all_controls:$list_all_controls) {
	...${fragmentType}
}
`;

const ADD_REQUEST_TYPE = `
	create_req_type(name: $name, is_private: $isPrivate, type: $type, template_id: $template_id, who_can_create: $who_can_create, generate_code: $generate_code, schedule_generate_code: $schedule_generate_code){
		...RequestTypeSimpleData
	}
`;

const UPDATE_REQUEST_TYPE = `
	update_req_type(id: $id, name: $name, disable: $disable, is_private: $isPrivate, type: $type, template_id: $template_id, who_can_create: $who_can_create, generate_code: $generate_code, schedule_generate_code: $schedule_generate_code){
		...RequestTypeSimpleData
	}
`;

const DELETE_REQUEST_TYPE = `
	delete_req_type(id: $id){
		...RequestTypeSimpleData
	}
`;

const GET_GENERAL = `
	general
`;

const ADD_DYNAMIC_FORM_FIELD = `
	create_control(
		title: $title,
		control: $control,
		children: $children,
		attributes: $attributes,
		is_optional: $is_optional,
		enable: $enable,
		description: $description,
		formable_id: $formable_id,
		formable_type: $formable_type
	){
		...DynamicFormField
	}
`;

const UPDATE_DYNAMIC_FORM_FIELD = `
	update_control(
		id: $id
		title: $title,
		control: $control,
		children: $children,
		attributes: $attributes,
		is_optional: $is_optional,
		enable: $enable,
		description: $description
	){
		...DynamicFormField
	}
`;

const DELETE_DYNAMIC_FORM_FIELD = `
	delete_control(
		id: $id
	){
		...DynamicFormField
	}
`;

const SORT_DYNAMIC_FORM_FIELD = `
	sort_controls(
		ids: $ids
	)
`;

const DELETE_REQUEST_TYPE_STEP = `
	delete_req_type_status(
		id: $id
	){
		...RequestStatus
	}
`;

const ADD_REQUEST_TYPE_STEP = `
	create_req_type_status(
		name: $name,
		req_type_id: $req_type_id,
		notifications: $notifications,
		description: $description,
		approverFillInfo: $approverFillInfo,
		color: $color
	){
		...RequestStatus
	}
`;

const UPDATE_REQUEST_TYPE_STEP = `
	update_req_type_status(
		id: $id,
		name: $name,
		notifications: $notifications,
		description: $description,
		approverFillInfo: $approverFillInfo,
		color: $color
	){
		...RequestStatus
	}
`;

const ADD_REQUEST_TYPE_STATISTICAL_EXPRESSION = `
	create_statistic_expression(
		req_type_id: $req_type_id,
		type: $type,
		name: $name,
		expression: $expression
	){
		...StatisticalExpression
	}
`;

const UPDATE_REQUEST_TYPE_STATISTICAL_EXPRESSION = `
	update_statistic_expression(
		id: $id,
		type: $type,
		name: $name,
		expression: $expression
	){
		...StatisticalExpression
	}
`;

const DELETE_REQUEST_TYPE_STATISTICAL_EXPRESSION = `
	delete_statistic_expression(
		id: $id
	){
		...StatisticalExpression
	}
`;

const GET_REQUESTS_BY_RELATIONS = `
	requests(limit: $limit,
		page: $page,
		orderBy: $orderBy,
		version: "V2",
		relations: $relations) {
		data {
			...RequestByRelations
		}
		total
	}
`;

const DUPLICATE_REQUEST = `
	clone_request (
		id: $id
	){
		...Request
	}
`;

const GET_REQUESTS_STATISTIC = `
	request_statistic (statuses: $statuses, department_ids:$department_ids )  {
		request_types{
			id
			name
			details{
			id
			name
			display
			}
		}
		department{
			id
			name
		}
	}
`;

const REQUEST_COUNT = `
	request_count  {
		id
		name
		display
	}
`;

const GET_APPROVER_DEPT_RESTRICTIONS = `
	approver_dept_restrictions(req_status_id: $req_status_id, employee_id: $employee_id) {
		id
		req_status_id
		employee_id
		department_id
		employee_name
		department_name
	}
`;

const SYNC_APPROVER_DEPT_RESTRICTIONS = `
	sync_approver_dept_restrictions(req_status_id: $req_status_id, employee_id: $employee_id, department_ids: $department_ids) {
		id
		req_status_id
		employee_id
		department_id
		employee_name
		department_name
	}
`;

export default {
	init() {},

	getRequestTypes(payload) {
		return graphqlClient
			.query({
				query: gql`query RequestTypes (
					$limit: Int!,
					$page: Int!,
					$keyword: String,
					$list_all: Boolean,
					$orderBy: OrderByObject
				) {
					${GET_REQUEST_TYPES}
				}
				${requestFragments.RequestTypes}
			`,
				variables: {
					page: payload.page || 1,
					keyword: payload.keyword,
					limit: payload.limit || -1,
					list_all: payload.list_all,
					orderBy: payload.orderBy || null
				}
			})
			.then(response => response.data.request_types);
	},

	getRequestTypeSimpleData(id, list_all_controls = false) {
		return graphqlClient
			.query({
				query: gql`query RequestTypeSimpleData ($id: Int!, $list_all_controls: Boolean) {
					${GET_REQUEST_TYPE("RequestTypeSimpleData")}
				}
				${requestFragments.RequestTypeSimpleData}
			`,
				variables: {
					id,
					list_all_controls
				}
			})
			.then(response => response.data.request_type);
	},

	getRequestType(id, list_all_controls = false) {
		return graphqlClient
			.query({
				query: gql`query RequestType ($id: Int!, $list_all_controls: Boolean) {
					${GET_REQUEST_TYPE("RequestType")}
				}
				${requestFragments.RequestType}
			`,
				variables: {
					id,
					list_all_controls
				}
			})
			.then(response => response.data.request_type);
	},

	getRequests(payload) {
		return graphqlClient
			.query({
				query: gql`query RequestManagement (
					$limit: Int!,
					$page: Int!,
					$search: String,
					$req_type_id: Int,
					$to_date: String,
					$can_edit: Boolean,
					$from_date: String,
					$list_statuses: [Int],
					$req_type_type_id: Int,
					$list_requested_by: [Int],
					$waiting_approval: Boolean,
					$advantage_search: String,
					$orderBy: OrderByObject,
					$requested_by_me: Boolean,
					$approve_by_me: Boolean,
					$department_ids: [Int],
					$user_option: String
				) {
					${GET_REQUESTS_V2}
				}
				${requestFragments.RequestSimpleData}
				`,
				variables: {
					limit: payload.limit || -1,
					page: payload.page || 1,
					search: payload.search || "",
					orderBy: payload.orderBy || null,
					to_date: payload.to_date || null,
					can_edit: payload.can_edit || null,
					from_date: payload.from_date || null,
					list_statuses: payload.list_statuses,
					req_type_id: payload.req_type_id,
					requested_by_me: payload.created_by_me || false,
					approve_by_me: payload.approve_by_me || false,
					req_type_type_id: payload.req_type_type_id,
					advantage_search: payload.advantage_search || null,
					waiting_approval: payload.waiting_approval || false,
					list_requested_by: payload.list_requested_by || null,
					department_ids: payload.department_ids || [],
					user_option: payload.user_option_color || null
				}
			})
			.then(response => response.data.requests);
	},

	getRelationByModel(payload) {
		return graphqlClient
			.query({
				query: gql`query RelationByModel ($model: String!, $name: String! ,$limit: Int!, $page: Int!, $ids: [Int]) {
				${RELATION_MODEL}
			}
			`,
				variables: {
					ids: payload.ids,
					page: payload.page,
					name: payload.name,
					limit: payload.limit,
					model: payload.model
				}
			})
			.then(response => (response.data.relation_model ? response.data.relation_model.data : []));
	},

	getRequest(id) {
		return graphqlClient
			.query({
				query: gql`query RequestDetail ($id: Int!) {
					${GET_REQUEST}
				}
				${requestFragments.Request}
			`,
				variables: {
					id
				}
			})
			.then(response => response.data.request);
	},

	getAutofillData(payload) {
		return graphqlClient
			.query({
				query: gql`query AutofillData ($model_id: Int!, $model_class: String!, $column: String!) {
					${GET_AUTOFILL}
				}
			`,
				variables: {
					model_id: payload.model_id,
					model_class: payload.model_class,
					column: payload.column
				}
			})
			.then(response => response.data.autofill_data);
	},

	approvedRequest(payload) {
		return graphqlClient
			.mutate({
				mutation: gql`mutation ApprovedRequest ($id: Int!, $note: String, $step_status: ReqStatusInput) {
					${APPROVED_REQUEST}
				}
				${requestFragments.Request}
			`,
				variables: {
					id: payload.id,
					note: payload.note || "",
					step_status: payload.step_status
				}
			})
			.then(response => response.data.approved_request);
	},

	rejectedRequest(payload) {
		return graphqlClient
			.mutate({
				mutation: gql`mutation RejectedRequest ($id: Int!, $reason: String!) {
					${REJECT_REQUEST}
				}
				${requestFragments.Request}
			`,
				variables: {
					id: payload.id,
					reason: payload.reason
				}
			})
			.then(response => response.data.reject_request);
	},

	submitRequest(payload) {
		return graphqlClient
			.mutate({
				mutation: gql`mutation SubmitRequest ($req_type_id: Int!, $request_reason: String!, $data: String!, $relations: [IdTypeInput], $step_status: ReqStatusInput) {
					${SUBMIT_REQUEST}
				}
				${requestFragments.Request}
			`,
				variables: {
					data: payload.data,
					relations: payload.relations,
					req_type_id: payload.req_type_id,
					step_status: payload.step_status,
					request_reason: payload.request_reason
				}
			})
			.then(response => response.data.submit_request);
	},

	updateRequest(payload) {
		return graphqlClient
			.mutate({
				mutation: gql`mutation UpdateRequest ($id: Int!, $request_reason: String!, $data: String!) {
					${UPDATE_REQUEST}

				}
				${requestFragments.Request}
			`,
				variables: {
					id: payload.id,
					request_reason: payload.request_reason,
					data: payload.data
				}
			})
			.then(response => response.data.update_request);
	},

	submitNextRequest(payload) {
		return graphqlClient
			.mutate({
				mutation: gql`mutation SubmitNextRequest ($id: Int!, $data: String!) {
					${SUBMIT_NEXT_REQUEST}
				}
				${requestFragments.Request}
			`,
				variables: {
					id: payload.id,
					data: payload.data
				}
			})
			.then(response => response.data.submit_next_request);
	},

	cancelRequest(payload) {
		return graphqlClient
			.mutate({
				mutation: gql`mutation CancelRequest ($id: Int!, $reason: String!) {
					${CANCEL_REQUEST}
				}
				${requestFragments.Request}
			`,
				variables: {
					id: payload.id,
					reason: payload.reason
				}
			})
			.then(response => response.data.cancel_request);
	},

	exportRequest(id) {
		return graphqlClient
			.mutate({
				mutation: gql`mutation ExportRequest ($id: Int!) {
					${EXPORT_REQUEST}
				}
			`,
				variables: {
					id
				}
			})
			.then(response => response.data.export_request);
	},

	exportFilteredRequest(payload) {
		return graphqlClient
			.mutate({
				mutation: gql`mutation ExportFilteredRequest (
					$search: String,
					$req_type_id: Int,
					$to_date: String,
					$from_date: String,
					$list_statuses: [Int],
					$list_requested_by: [Int],
					$waiting_approval: Boolean,
					$advantage_search: String,
					$department_ids: [Int]
				) {
					${EXPORT_FILTERED_REQUEST}
				}
			`,
				variables: {
					search: payload.search || "",
					to_date: payload.to_date || null,
					from_date: payload.from_date || null,
					list_statuses: payload.list_statuses,
					req_type_id: payload.req_type_id || null,
					list_requested_by: payload.list_requested_by || null,
					department_ids: payload.department_ids || null,
					waiting_approval: payload.waiting_approval || false,
					advantage_search: payload.advantage_search || null
				}
			})
			.then(response => response.data.export_request_list);
	},

	exportFilteredRequestStatistic(payload) {
		return graphqlClient
			.mutate({
				mutation: gql`mutation ExportFilteredRequestStatistic (
					$search: String,
					$req_type_id: Int,
					$to_date: String,
					$from_date: String,
					$list_statuses: [Int],
					$list_requested_by: [Int],
					$waiting_approval: Boolean,
					$advantage_search: String
				) {
					${EXPORT_FILTERED_REQUEST_STATISTIC}
				}
			`,
				variables: {
					search: payload.search || "",
					to_date: payload.to_date || null,
					from_date: payload.from_date || null,
					list_statuses: payload.list_statuses,
					req_type_id: payload.req_type_id || null,
					list_requested_by: payload.list_requested_by || null,
					waiting_approval: payload.waiting_approval || false,
					advantage_search: payload.advantage_search || null
				}
			})
			.then(response => response.data.export_request_statistic);
	},

	addRequestType(payload) {
		return graphqlClient
			.mutate({
				mutation: gql`mutation AddRequestType ($template_id: Int, $name: String!, $isPrivate: Boolean, $type: Int!, $who_can_create: [IdTypeInput], $generate_code: String, $schedule_generate_code: Int) {
					${ADD_REQUEST_TYPE}
				}
				${requestFragments.RequestTypeSimpleData}
			`,
				variables: {
					type: payload.type,
					name: payload.name || "",
					isPrivate: payload.isPrivate,
					template_id: payload.template_id,
					who_can_create: payload.who_can_create,
					generate_code: payload.generate_code || "",
					schedule_generate_code: payload.schedule_generate_code || 1
				}
			})
			.then(response => response.data.create_req_type);
	},

	updateRequestType(payload) {
		return graphqlClient
			.mutate({
				mutation: gql`mutation UpdateRequestType ($id: Int!, $disable: Boolean, $isPrivate: Boolean, $template_id: Int, $name: String!, $type: Int!, $who_can_create: [IdTypeInput], $generate_code: String, $schedule_generate_code: Int) {
					${UPDATE_REQUEST_TYPE}
				}
				${requestFragments.RequestTypeSimpleData}
			`,
				variables: {
					id: payload.id,
					type: payload.type,
					name: payload.name,
					disable: payload.disable,
					isPrivate: payload.isPrivate,
					template_id: payload.template_id,
					who_can_create: payload.who_can_create,
					generate_code: payload.generate_code || "",
					schedule_generate_code: payload.schedule_generate_code || 1
				}
			})
			.then(response => response.data.update_req_type);
	},

	deleteRequestType(id) {
		return graphqlClient
			.mutate({
				mutation: gql`mutation DeleteRequestType ($id: Int!) {
					${DELETE_REQUEST_TYPE}
				}
				${requestFragments.RequestTypeSimpleData}
			`,
				variables: {
					id
				}
			})
			.then(response => response.data.delete_req_type);
	},

	getGeneral() {
		return graphqlClient
			.query({
				query: gql`query GetGeneral {
					${GET_GENERAL}
				}
			`
			})
			.then(response => response.data.general);
	},

	getCombinedRelationDataByModel(payload) {
		const mappedQueries = _.map(
			payload,
			(value, key) => `
			${key.split("\\").join("")}: relation_model(model: "${key.split("\\").join("\\\\")}", page: 1, limit: ${value.length}, ids: [${value}]) {
				total
				data {
					id
					content
				}
			}
		`
		);

		return graphqlClient
			.query({
				query: gql`query GetCombinedRelationModelData {
					${mappedQueries}
				}
			`
			})
			.then(response => response.data);
	},

	addDynamicFormField(payload) {
		return graphqlClient
			.mutate({
				mutation: gql`mutation AddDynamicFormField (
					$control: Int!,
					$title: String!,
					$children: String,
					$formable_id: Int,
					$attributes: String!,
					$is_optional: Boolean!,
					$enable: Boolean!,
					$formable_type: String,
					$description: FormInfoInput
				) {
					${ADD_DYNAMIC_FORM_FIELD}
				}
				${requestFragments.DynamicFormField}
			`,
				variables: {
					title: payload.title,
					control: payload.control,
					children: payload.children,
					attributes: payload.attributes,
					description: payload.description,
					is_optional: payload.is_optional,
					enable: payload.enable,
					formable_id: payload.formable_id,
					formable_type: payload.formable_type
				}
			})
			.then(response => response.data.create_control);
	},

	updateDynamicFormField(payload) {
		return graphqlClient
			.mutate({
				mutation: gql`mutation UpdateDynamicFormField (
					$id: Int!,
					$control: Int!,
					$title: String!,
					$children: String,
					$attributes: String!,
					$is_optional: Boolean!,
					$enable: Boolean!,
					$description: FormInfoInput
				) {
					${UPDATE_DYNAMIC_FORM_FIELD}
				}
				${requestFragments.DynamicFormField}
			`,
				variables: {
					id: payload.id,
					title: payload.title,
					control: payload.control,
					children: payload.children,
					attributes: payload.attributes,
					description: payload.description,
					is_optional: payload.is_optional,
					enable: payload.enable
				}
			})
			.then(response => response.data.update_control);
	},

	deleteDynamicFormField(id) {
		return graphqlClient
			.mutate({
				mutation: gql`mutation DeleteDynamicFormField ($id: Int!) {
					${DELETE_DYNAMIC_FORM_FIELD}
				}
				${requestFragments.DynamicFormField}
			`,
				variables: {
					id
				}
			})
			.then(response => response.data.delete_control);
	},

	sortDynamicFormField(ids) {
		return graphqlClient
			.mutate({
				mutation: gql`mutation SortDynamicFormField ($ids: [Int!]) {
					${SORT_DYNAMIC_FORM_FIELD}
				}
			`,
				variables: {
					ids
				}
			})
			.then(response => response.data.sort_controls);
	},

	addRequestTypeStep(payload) {
		return graphqlClient
			.mutate({
				mutation: gql`mutation AddRequestTypeStep ($req_type_id: Int!, $name: String, $notifications: NotificationStatusInput, $description: String, $approverFillInfo: Boolean, $color: String) {
					${ADD_REQUEST_TYPE_STEP}
				}
				${requestFragments.RequestStatus}
			`,
				variables: {
					name: payload.name,
					req_type_id: payload.req_type_id,
					notifications: payload.notifications,
					description: payload.description || "",
					approverFillInfo: payload.approverFillInfo || false,
					color: payload.color || null
				}
			})
			.then(response => response.data.create_req_type_status);
	},

	updateRequestTypeStep(payload) {
		return graphqlClient
			.mutate({
				mutation: gql`mutation UpdateRequestTypeStep ($id: Int!, $name: String, $notifications: NotificationStatusInput, $description: String, $approverFillInfo: Boolean, $color: String) {
					${UPDATE_REQUEST_TYPE_STEP}
				}
				${requestFragments.RequestStatus}
			`,
				variables: {
					id: payload.id,
					name: payload.name,
					notifications: payload.notifications,
					description: payload.description || "",
					approverFillInfo: payload.approverFillInfo || false,
					color: payload.color || null
				}
			})
			.then(response => response.data.update_req_type_status);
	},

	deleteRequestTypeStep(id) {
		return graphqlClient
			.mutate({
				mutation: gql`mutation DeleteRequestTypeStep ($id: Int!) {
					${DELETE_REQUEST_TYPE_STEP}
				}
				${requestFragments.RequestStatus}
			`,
				variables: {
					id
				}
			})
			.then(response => response.data.delete_req_type_status);
	},

	addRequestTypeStatisticalExpression(payload) {
		return graphqlClient
			.mutate({
				mutation: gql`mutation AddRequestTypeStatisticalExpression ($req_type_id: Int!, $type: Int, $name: String, $expression: String) {
					${ADD_REQUEST_TYPE_STATISTICAL_EXPRESSION}
				}
				${requestFragments.StatisticalExpression}
			`,
				variables: {
					name: payload.name,
					type: payload.type,
					expression: payload.expression,
					req_type_id: payload.req_type_id
				}
			})
			.then(response => response.data.create_statistic_expression);
	},

	updateRequestTypeStatisticalExpression(payload) {
		return graphqlClient
			.mutate({
				mutation: gql`mutation UpdateRequestTypeStatisticalExpression ($id: Int!, $type: Int, $name: String, $expression: String) {
					${UPDATE_REQUEST_TYPE_STATISTICAL_EXPRESSION}
				}
				${requestFragments.StatisticalExpression}
			`,
				variables: {
					id: payload.id,
					name: payload.name,
					type: payload.type,
					expression: payload.expression
				}
			})
			.then(response => response.data.update_statistic_expression);
	},

	deleteRequestTypeStatisticalExpression(id) {
		return graphqlClient
			.mutate({
				mutation: gql`mutation DeleteRequestTypeStatisticalExpression ($id: Int!) {
					${DELETE_REQUEST_TYPE_STATISTICAL_EXPRESSION}
				}
				${requestFragments.StatisticalExpression}
			`,
				variables: {
					id
				}
			})
			.then(response => response.data.delete_statistic_expression);
	},

	getRequestsByRelations(payload) {
		return graphqlClient
			.query({
				query: gql`query RequestManagement (
					$limit: Int!,
					$page: Int!,
					$orderBy: OrderByObject
					$relations: [IdTypeInput]
				) {
					${GET_REQUESTS_BY_RELATIONS}
				}
				${requestFragments.RequestByRelations}
				`,
				variables: {
					limit: payload.limit || -1,
					page: payload.page || 1,
					orderBy: payload.orderBy || null,
					relations: payload.relations || []
				}
			})
			.then(response => {
				return {
					requests: response.data.requests.data,
					total: response.data.requests.total
				};
			});
	},

	duplicateRequest(id) {
		return graphqlClient
			.mutate({
				mutation: gql`mutation DuplicateRequest ($id: Int!) {
					${DUPLICATE_REQUEST}
				}
				${requestFragments.Request}
			`,
				variables: {
					id
				}
			})
			.then(response => response.data.clone_request);
	},

	getRequestsStatistic(payload) {
		return graphqlClient
			.query({
				query: gql`query RequestsStatistic (
					$statuses: [Int],
					$department_ids: [Int]
				) {
					${GET_REQUESTS_STATISTIC}
				}
				`,
				variables: {
					statuses: (payload && payload.statuses) || [],
					department_ids: (payload && payload.department_ids) || []
				}
			})
			.then(response => {
				return {
					request_statistic: response.data.request_statistic
				};
			});
	},
	getRequestListCount() {
		const queryOptions = {
			query: gql`query RequestListCount {
					${REQUEST_COUNT}
				}
			`
		};
		return graphqlClient.query(queryOptions).then(response => response.data.request_count);
	},

	getApproverDeptRestrictions(payload) {
		return graphqlClient
			.query({
				query: gql`query ApproverDeptRestrictions ($req_status_id: Int!, $employee_id: Int) {
					${GET_APPROVER_DEPT_RESTRICTIONS}
				}
				`,
				variables: {
					req_status_id: payload.req_status_id,
					employee_id: payload.employee_id || null
				}
			})
			.then(response => response.data.approver_dept_restrictions);
	},

	syncApproverDeptRestrictions(payload) {
		return graphqlClient
			.mutate({
				mutation: gql`mutation SyncApproverDeptRestrictions ($req_status_id: Int!, $employee_id: Int!, $department_ids: [Int]) {
					${SYNC_APPROVER_DEPT_RESTRICTIONS}
				}
				`,
				variables: {
					req_status_id: payload.req_status_id,
					employee_id: payload.employee_id,
					department_ids: payload.department_ids
				}
			})
			.then(response => response.data.sync_approver_dept_restrictions);
	}
};
